import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { login } from "../api/kindergartenApi";
import { IRoleChangeItem } from "../models/User/UserRoleChangeResponse";
import { consumeOnBehalfRoleId } from "../utils";

interface ApplicationState {
  currentRole: IRoleChangeItem | null;
  currentRoleFetched: boolean;
  currentRoleLoading: boolean;
}

const initialState: ApplicationState = {
  currentRole: null,
  currentRoleFetched: false,
  currentRoleLoading: false,
};

export const fetchCurrentRole = createAsyncThunk(
  "application/fetchCurrentRole",
  async () => {
    return await login(consumeOnBehalfRoleId());
  }
);

const applicationSlice = createSlice({
  name: "application",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCurrentRole.pending, (state) => {
        state.currentRoleLoading = true;
      })
      .addCase(fetchCurrentRole.fulfilled, (state, { payload }) => {
        state.currentRoleLoading = false;
        state.currentRoleFetched = true;
        state.currentRole = payload;
      })
      .addCase(fetchCurrentRole.rejected, (state) => {
        state.currentRoleLoading = false;
        state.currentRoleFetched = true;
      });
  },
});

export default applicationSlice.reducer;
